import React, { useEffect, useState } from "react";
import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from "@material-ui/core";
import FileUploader from "common/FileUploader";
import { Orientation } from "get-orientation";

export default ({ initialValue, onSubmit, handleEdit }) => {

    const actionName = Object.keys(initialValue)[0];
    const actionValue = initialValue[actionName];
    const [compress, setCompress] = useState(
        actionName === "compress"
            ? actionValue
            : {
                module: "buzzle-action-handbrake",
                preset: null,
                output: "encoded.mp4",
            }
    );
    const [rotateAction, setRotateAction] = useState(
        actionName === "rotateAction"
            ? actionValue
            : {
                module: "buzzle-action-video-orientation",
            }
    );
    const [addWatermark, setAddWatermark] = useState(
        actionName === "addWatermark"
            ? actionValue
            : {
                module: "buzzle-action-watermark",
                watermark: null,
            }
    );
    const [addThumbnail, setAddThumbnail] = useState(
        actionName === "addThumbnail"
            ? actionValue
            : {
                module: "buzzle-action-add-thumbnail",
                thumbnail: null,
                thumbnailDuration: 1,
            }
    );
    const [upload, setUpload] = useState(
        actionName === "upload"
            ? actionValue
            : {
                module: "buzzle-action-upload",
                input: "encoded.mp4",
                provider: "s3",
                params: {
                    region: "us-east-1",
                    bucket: "bulaava-assets",
                    key: `outputs/${Date.now()}.mp4`,
                    //TODO better acl policy
                    acl: "public-read",
                },
            }
    );
    const [mergeVideos, setMergeVideos] = useState(
        actionName === "mergeVideos"
            ? actionValue
            : {
                module: "buzzle-action-merge-videos",
                input2: "",

            }
    );
    const [addAudio, setAddAudio] = useState(
        actionName === "addAudio"
            ? actionValue
            : {
                module: "buzzle-action-add-audio",
                audio: ""
            }
    );

    const [fileError, setFileError] = useState(null);
    const [action, setAction] = useState(actionName);
    useEffect(() => {
        if (action) {
            handleEdit({
                [action]: eval(action)
            });
        }
    }, [action])
    const renderCompress = () => {
        return (
            <>
                <FormControl fullWidth margin="dense" variant="outlined">
                    <InputLabel id="property-select">Preset</InputLabel>

                    <Select
                        labelId="property-select"
                        id="property-select"
                        onChange={(e) => {
                            setCompress({ ...compress, preset: e?.target?.value });
                            handleEdit({
                                compress: { ...compress, preset: e?.target?.value },
                            });
                        }}
                        name="property"
                        value={compress.preset}
                        placeholder="Select Preset"
                        label="Preset">
                        {presets.map((item, index) => (
                            <MenuItem
                                key={index}
                                id={index}
                                value={item}
                                children={item}
                                selected={compress.preset === item}
                            />
                        ))}
                    </Select>
                </FormControl>
                <TextField
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    value={compress.output}
                    onChange={(e) => {
                        setCompress({ ...compress, output: e.target.value });
                        handleEdit({ compress: { ...compress, output: e?.target?.value } });
                    }}
                    type="text"
                    label={"Output"}
                    placeholder={"Enter Output filename"}
                />
            </>
        );
    };
    const renderUpload = () => {
        return (
            <>
                <TextField
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    value={upload.input}
                    onChange={(e) => {
                        setUpload({ ...upload, input: e.target.value });
                        handleEdit({ upload: { ...upload, input: e?.target?.value } });
                    }}
                    type="text"
                    label={"Input"}
                    placeholder={"Enter Input filename"}
                />
                <TextField
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    value={upload.params.key}
                    onChange={(e) => {
                        setUpload({
                            ...upload,
                            params: { ...upload.params, key: e.target.value },
                        });
                        handleEdit({
                            upload: {
                                ...upload,
                                params: { ...upload.params, key: e.target.value },
                            },
                        });
                    }}
                    type="text"
                    label={"S3 File Name"}
                    placeholder={"Enter filename"}
                    helperText={
                        "use examplePath/ before the name for uploading inside the directory"
                    }
                />
            </>
        );
    };
    const renderWatermark = () => {
        return (
            <><FileUploader
                name={"watermarkFile"}
                value={addWatermark.watermark}
                onError={(e) => setFileError(e.message)}
                onChange={(url) => {
                    setAddWatermark({ ...addWatermark, watermark: url });
                    handleEdit({ addWatermark: { ...addWatermark, watermark: url } });
                }}
                accept={"image/*"}
                uploadDirectory={"jobImages"}
                label="Watermark"
                onTouched={() => setFileError(null)}
                error={fileError}
                helperText={"Watermark should be transparent."}
            />
            </>
        );
    };
    const renderAddThumbnail = () => {
        return <>
            <TextField
                fullWidth
                variant="outlined"
                margin="dense"
                value={addThumbnail.thumbnailDuration}
                onChange={(e) => {
                    setAddThumbnail({ ...addThumbnail, thumbnailDuration: e.target.value });
                    handleEdit({ addThumbnail: { ...addThumbnail, thumbnailDuration: e?.target?.value } });
                }}
                type="text"
                label={"Thumbnail durationa in frames"}
                placeholder={"Enter duration number"}
            />
            <FileUploader
                name={"thumbnailFile"}
                value={addThumbnail.thumbnail}
                onError={(e) => setFileError(e.message)}
                onChange={(url) => {
                    setAddThumbnail({ ...addThumbnail, thumbnail: url });
                    handleEdit({ addThumbnail: { ...addThumbnail, thumbnail: url } });
                }}
                uploadDirectory={"jobImages"}
                accept={"image/*"}
                label="Thumbnail"
                onTouched={() => setFileError(null)}
                error={fileError}
                helperText={"Thumbnail would be resized to fit."}
            />
        </>
    }
    const renderMergeVideos = () => {
        return (
            <>
                <FileUploader
                    value={mergeVideos.input2}
                    onError={(e) => setFileError(e.message)}
                    onChange={(url) => {
                        setMergeVideos({ ...mergeVideos, input2: url, });
                        handleEdit({ mergeVideos: { ...mergeVideos, input2: url, } });
                    }}
                    accept={"video/*"}
                    uploadDirectory={"jobImages"}

                    name={"input2"}
                    label="Video File To be Merged"
                    onTouched={() => setFileError(null)}
                    error={fileError}
                    helperText={"Choose Video to be merged"}
                />
            </>
        );
    };
    const renderRotateAction = () => {

        const transposeOptions = [{ title: "90 Counter-CLockwise and Vertical Flip", value: 0 },
        { title: "90 Clockwise", value: 1 },
        { title: "90 Counter Clockwise", value: 2 },
        { title: "90 Clockwise and Vertical Flip", value: 3 }]
        return (<>
            <FormControl fullWidth margin="dense" variant="outlined">
                <InputLabel id="property-select">Output Orientation</InputLabel>
                <Select
                    labelId="orientation-select"
                    id="orientation-select"
                    onChange={(e) => {
                        setRotateAction({ ...rotateAction, orientation: (e?.target?.value) });
                        handleEdit({ rotateAction: { ...rotateAction, orientation: (e?.target?.value) } });
                    }}
                    name="orientation"
                    value={rotateAction?.orientation ?? 'portrait'}
                    placeholder="Select Output Orientation"
                    label="Select Output Orientation">
                    {["landscape", 'portrait'].map((item, index) => (
                        <MenuItem
                            key={index}
                            id={index}
                            value={item}
                            children={item.toUpperCase()}
                            selected={rotateAction.orientation === item}
                        />
                    ))}
                </Select>
            </FormControl>
            <FormControl fullWidth margin="dense" variant="outlined">
                <InputLabel id="transpose-select">Transpose option</InputLabel>
                <Select
                    labelId="transpose-select"
                    id="transpose-select"
                    onChange={(e) => {
                        setRotateAction({ ...rotateAction, transpose: parseInt(e?.target?.value) });
                        handleEdit({ rotateAction: { ...rotateAction, transpose: parseInt(e?.target?.value) } });
                    }}
                    name="orientation"
                    value={rotateAction?.transpose ?? 1}
                    placeholder="Select transpose"
                    label="Select transpose">
                    {transposeOptions.map((item, index) => (
                        <MenuItem
                            key={item.value}
                            id={index}
                            value={item.value}
                            children={item.title}
                            selected={rotateAction.transpose === item.value}
                        />
                    ))}
                </Select>
            </FormControl>
        </>)
    }
    const renderAddAudio = () => {
        return (
            <>
                <FileUploader
                    value={addAudio.audio}
                    onError={(e) => setFileError(e.message)}
                    onChange={(url) => {
                        setAddAudio({ ...addAudio, audio: url });
                        handleEdit({ addAudio: { ...addAudio, audio: url } });
                    }}
                    accept={"audio/*"}
                    uploadDirectory={"jobImages"}
                    name={"audio"}
                    label="Audio File"
                    onTouched={() => setFileError(null)}
                    error={fileError}
                    helperText={"Choose Audio file."}
                />
                {addAudio.audio && <audio controls>
                    <source src={addAudio.audio} type="audio/mpeg" />
                </audio>}
            </>
        );
    };
    const presets = ["mp4", "ogg", "webm", "mp3", "m4a", "gif"];
    const actions = {
        compress: renderCompress(),
        upload: renderUpload(),
        addWatermark: renderWatermark(),
        mergeVideos: renderMergeVideos(),
        addAudio: renderAddAudio(),
        addThumbnail: renderAddThumbnail(),
        rotateAction: renderRotateAction()
    };

    return (
        <>
            <FormControl fullWidth margin="dense" variant="outlined">
                <InputLabel id="property-select">Action Name</InputLabel>
                <Select
                    labelId="property-select"
                    id="property-select"
                    onChange={(e) => setAction(e?.target?.value)}
                    name="property"
                    value={actionName}
                    placeholder="Select Action"
                    label="Action Name">
                    {Object.keys(actions).map((item, index) => (
                        <MenuItem
                            key={index}
                            id={index}
                            value={item}
                            children={item}
                            selected={actionName === item}
                        />
                    ))}
                </Select>
            </FormControl>
            {actions[action]}
        </>
    );
};









